'use strict';
var create = require('./_object-create');
var descriptor = require('./_property-desc');
var setToStringTag = require('./_set-to-string-tag');
var IteratorPrototype = {};

// 25.1.2.1.1 %IteratorPrototype%[@@iterator]()
require('./_hide')(IteratorPrototype, require('./_wks')('iterator'), function () { return this; });

module.exports = function (Constructor, NAME, next) {
  Constructor.prototype = create(IteratorPrototype, { next: descriptor(1, next) });
  setToStringTag(Constructor, NAME + ' Iterator');
};



//////////////////
// WEBPACK FOOTER
// ./~/core-js/library/modules/_iter-create.js
// module id = 40
// module chunks = 0 3 4 7 8 9 10 12 13 16 17 18 20 23 24 25 26 27 30 31 32 33 34 35 36 37 38 39 40 41 43 44 46 48 49 52 53 54 55 56 59 61 63 65 66 67 68 70 72 73 74 77 78 79 80 81 82 83 85 88 89 92 93 94 95 97 100 101 103 104 105 106 109 111 113 114 118 119 120 121 125 127 129 133 134 135 140 141 142 143 144 145 146 147 148 149 150 151 154 155 156 157 159 162 163 164 165 166 168 169 170 171 172 173